import { Component, Input, OnInit } from '@angular/core';
import { DimensionesAnualPMEModel, SubdimensionAnualPMEModel } from 'src/app/model/NewFaseAnual.model';

@Component({
  selector: 'app-pme-subdimensiones-fase-anual',
  templateUrl: './pme-subdimensiones-fase-anual.component.html',
  styleUrls: ['./pme-subdimensiones-fase-anual.component.css']
})
export class PmeSubdimensionesFaseAnualComponent implements OnInit {

  @Input() indice : number;
  @Input() estadoData : number;
  @Input() areaNumber : number;
  @Input() dimensionData : DimensionesAnualPMEModel;
  @Input() subdimensionData : SubdimensionAnualPMEModel;
  @Input() simulacion: boolean;
  

  constructor(
    //@Inject(FaseEstrategicaComponent) private parentFE: FaseEstrategicaComponent,
  ) { }

  ngOnInit(): void {  

  }

  
}
